import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProSidebar, SidebarHeader, SidebarFooter, SidebarContent, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { useHistory } from 'react-router';
import menus from './menu';

import './style.css';

const AdminSidebar = ({ setCollapsedMenu, collapsedMenu, toggled, setToggled }) => {
    const history = useHistory();

    const handleCollapsed = () => {
        setCollapsedMenu(!collapsedMenu);
    };

    return (
        <React.Fragment>
            <ProSidebar
                collapsed={collapsedMenu}
                toggled={toggled}
                breakPoint="sm"
                onToggle={() => setToggled(!toggled)}
            >
                <SidebarContent>
                    <Menu iconShape="circle">
                        {
                            menus.map((menu, index) => {
                                return menu.submenus.length <= 0
                                    ? <MenuItem
                                        key={index}
                                        icon={<FontAwesomeIcon icon={['fas', `${menu.icon}`]} />}
                                        onClick={() => history.push(`${menu.path}`)}
                                        active={location.pathname === menu.path}
                                    >{menu.name}</MenuItem>
                                    : <SubMenu
                                        key={index}
                                        title={menu.name}
                                        icon={<FontAwesomeIcon icon={['fas', `${menu.icon}`]} />}
                                    >
                                        {
                                            menu.submenus.map((submenu, subIndex) => <MenuItem
                                                key={`sub-${index}-${subIndex}`}
                                                onClick={() => history.push(`${submenu.path}`)}
                                                active={location.pathname === submenu.path}
                                            >{submenu.name}</MenuItem>)
                                        }
                                    </SubMenu>;
                            })
                        }
                    </Menu>
                </SidebarContent>
                <SidebarFooter>
                    <div className="text-right p-1 collapse-container">
                        <button
                            type="button"
                            style={{ border: 0, background: 'none', color: '#fcfcfc' }}
                            onClick={handleCollapsed}
                        >
                            {
                                collapsedMenu
                                    ? <FontAwesomeIcon icon={['fas', 'arrow-alt-circle-right']} />
                                    : <FontAwesomeIcon icon={['fas', 'arrow-alt-circle-left']} />
                            }
                        </button>
                    </div>
                </SidebarFooter>
            </ProSidebar>
        </React.Fragment>
    );
};

export default AdminSidebar;